<template>
  <div class="lebot-balao" :class="{'is-me': m.is_me}" :data-id="m.external_id">
    <div v-if="content">
      <div class="mt-2" v-if="m.media">
        <audio controls autoplay v-if="content.media.type === 'audio'">
          <source :src="m.media.base64" type="audio/ogg"/>
        </audio>
        <video :src="m.media.base64" controls autoplay v-else-if="content.media.type === 'video'" style="max-width: 250px; max-height: 350px"></video>
        <a :href="m.media.base64" :download="content.media.filename" v-else-if="content.media.type === 'document'" class="text-decoration-none">
          <span class="icon"><i class="fas fa-file-alt"></i></span> {{content.media.filename || 'Documento'}} <i class="fas fa-arrow-alt-circle-down ml-1"></i>
        </a>
        <a href="javascript:" @click="$emit('openMedia', m.media.base64)" v-else>
          <img class="lebot-balao-img mb-2" :src="m.media.base64"/>
        </a>
      </div>
      <a href="javascript:" class="text-decoration-none" @click="loadMedia(m)" v-else-if="content.type === 'media'">
        <div class="text-dark m-2 mr-4" v-if="load">
          <i class="fas fa-spinner fa-pulse mr-1"></i> baixando o arquivo..
        </div>
        <div class="mt-2" v-else>
          <div v-if="content.media.type === 'audio'"><span class="icon"><i class="fas fa-headphones"></i></span> Reproduzir audio</div>
          <div v-else-if="content.media.type === 'video'"><span class="icon"><i class="fas fa-file-video"></i></span> Reproduzir vídeo</div>
          <div v-else-if="content.media.type === 'document'">
            <span class="icon"><i class="fas fa-file-alt"></i></span>
            {{content.media.filename || 'Documento'}} <i class="fas fa-arrow-alt-circle-down ml-1"></i>
          </div>
          <div v-else><span class="icon"><i class="fas fa-file-image"></i></span> Visualizar Imagem</div>
        </div>
      </a>
      <div v-else-if="content.type === 'contact'">
        <div class="bg-primary p-1 rounded-sm text-white mb-2 text-center">Contatos</div>
        <div class="mb-2" v-for="c in content.contact">
          Nome: {{c.name}} <br>
          Telefones: <span v-for="p in c.phones" class="mr-2">{{p.number}}</span>
        </div>
      </div>
      <div class="lebot-balao-body" v-else-if="content.type === 'interaction'">
        <div v-if="content.interaction.type === 'selection'">
          {{content.interaction.selected.label}}
        </div>
        <div v-if="content.interaction.type === 'buttons'">
          {{content.text}}
          <div class="interaction-options mt-2">
            <div class="interaction-option" v-for="option in content.interaction.options" :key="option.id">
              {{option.label}}
            </div>
          </div>
        </div>
        <div v-if="content.interaction.type === 'list'">
          {{content.text}}
          <details class="interaction-list mt-2">
            <summary>
              <i class="fa fa-bars mr-1"></i>
              Lista interativa · {{interactionOptions.length}} {{interactionOptions.length === 1 ? 'opção' : 'opções'}}
            </summary>
            <div class="interaction-options mt-2">
              <div class="interaction-option" v-for="option in interactionOptions" :key="option.id">
                {{option.label}}
              </div>
            </div>
          </details>
        </div>
      </div>
      <div class="lebot-balao-body" v-else-if="text" v-html="text"></div>
      <div v-else>
        Formato de mensagem ainda não suportado
      </div>
      <div class="balao-hora">
        <span>{{ m.send_date || m.send_hour }}</span>
        <i class="balao-status small fa ml-1" :class="m.status | status" v-if="m.is_me"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { formatWhatsAppText } from '@/services/WhatsAppTextFormatter';

export default {
  name: "LebotBalao",
  props: ['m'],
  data() {
    return {
      text: null,
      load: false
    }
  },
  computed: {
    content() {
      return this.m.content;
    },

    interactionOptions() {
      return this.content
        && this.content.interaction
        && Array.isArray(this.content.interaction.options)
        ? this.content.interaction.options
        : [];
    }
  },
  methods: {
    baixarArquivo(base64, filename){
      const a = document.createElement('a');
      a.href = base64;
      a.download = filename;
      a.click();
    },

    loadMedia(m) {
      if (this.load) {
        return;
      }
      
      const media = m.content && m.content.media;

      if (media) {
        this.load = true;

        this.$http.get(`messages/${m.id}/media`)
          .then(response => {
            this.load = false;

            if (response.data.media) {
              let mimeTipe = media.mime_type || response.data.mime_type;

              m.media = {
                caption: media.caption || null,
                base64: `data:${mimeTipe};base64,${response.data.media}`
              };

              if (media.type === 'document') {
                this.baixarArquivo(m.media.base64, media.filename);
              }

            } else {
              this.$swal("Este arquivo não está mais disponível. Peça para este contato encaminhar novamente.");
            }

          }, res => {
            this.load = false;
            this.$swal("Não foi possível carregar este arquivo");
            console.log(res);
          });
      }
    },

    iniciar(m) {
      const content = m.content;

      if (!content) {
        this.text = null;
        return;
      }

      switch (content.type) {
        case 'text':
          this.text = formatWhatsAppText(content.text || '');
          break;
        case 'media':
          this.text = content.media.caption
            ? formatWhatsAppText(content.media.caption)
            : null;
          break;
        default:
          this.text = null;
      }
    }
  },

  mounted() {
    this.iniciar(this.m);
  },

  filters: {
    status(value) {
      switch (value) {
        case 'sent':
          return 'fa-check';
        case 'read':
          return 'fa-check read';
        case 'failed':
          return 'fa-exclamation-triangle failed';
        default:
          return 'fa-clock'
      }
    }
  },

  watch: {
    m(val) {
      this.iniciar(val);
    }
  }
}
</script>
<style scoped>
.lebot-balao {
  background-color: #ffffff;
  display: inline-block;
  padding: 6px 7px 8px 9px;
  font-size: 14px;
  border-radius: 0 6px 6px 6px;
  box-shadow: 0 1px 1px rgba(0,0,0,.13);
  max-width: 80%;
  min-width: 120px;
  text-align: left;
  position: relative;
}

.lebot-balao.is-me {
  background-color: #D9FDD3;
  margin-left: auto;
}

.lebot-balao-body {
  display: inline-block;
  width: 100%;
  position: relative;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.interaction-options {
  display: grid;
  gap: 5px;
  min-width: 150px;
}

.interaction-option {
  padding: 5px 9px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.45);
  color: #343a40;
}

.interaction-list summary {
  cursor: pointer;
  color: #495057;
  font-weight: 600;
  list-style-position: inside;
}

.balao-hora {
  margin: 5px 2px -3px;
  text-align: right;
  font-size: 12px;
  opacity: 0.7;
}

.icon {
  margin-right: 2px;
  display: inline-block;
}

.icon i {
  font-size: 22px;
}

.read {
  color: #53bdeb!important;
}

.failed {
  color: var(--warning);
}

.lebot-balao-img {
  width: 200px;
  height: 200px;
  object-fit: cover;
  max-width: 100%;
  border-radius: 4px;
}
</style>
